import ReconnectingWebSocket from 'reconnecting-websocket'

import { useEffect, useRef, useState } from 'react'
import isEnv from 'helpers/is/isEnv'
import { logger } from 'helpers/logger'
import { useSelector } from 'react-redux'
import { authSlice } from '@wellesley/auth/authSlice'

type UseConnectProps = {
  onReady: (isReady: boolean) => void
}

export const useConnect = ({ onReady }: UseConnectProps) => {
  const token = useSelector(authSlice.selectors.selectToken)
  const wsRef = useRef<ReconnectingWebSocket | null>(null)
  const [socket, setSocket] = useState<ReconnectingWebSocket | null>(null)
  wsRef.current = socket

  const closeSocket = () => {
    if (wsRef.current?.readyState === wsRef.current?.OPEN) {
      try {
        onReady(false)
        wsRef.current?.close()
      } catch (e) {
        logger.error('WebSocket error when close: ', e)
      }
    }
  }

  const connect = () => {
    const domain = isEnv('dev')
      ? new URL(process.env.DEV_API_URL!).hostname
      : location.hostname

    const tokenQuery = token ? `?access_token=${token}` : ''
    const ws = new ReconnectingWebSocket(
      `wss://${domain}/api/v1/streaming${tokenQuery}`,
    )

    setSocket(ws)
  }

  useEffect(() => () => closeSocket(), [])

  useEffect(() => {
    connect()
    return () => closeSocket()
  }, [token])

  return { socket }
}
